import app from './app';

(async () => {
  const loaded = await app;

  loaded.$mount('#app');
})();
